import { formatarNumero_recebido_com_casa_decimais, formatarNumero_recebido_com_casa_decimais_aux, formatarNumero_recebido_sem_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_cabecalho5(item: any) {
    return {
        ...item,
        area: formatarNumero_recebido_com_casa_decimais(item.area),
        esperada: formatarNumero_recebido_com_casa_decimais(item.esperada),
        obtida: formatarNumero_recebido_com_casa_decimais(item.obtida),
        n_plantas: formatarNumero_recebido_sem_casa_decimais(item.n_plantas),
        n_contador: formatarNumero_recebido_com_casa_decimais(item.n_contador),
        leitura_contador_preimeira: formatarNumero_recebido_sem_casa_decimais(item.leitura_contador_preimeira),
        c_e: formatarNumero_recebido_com_casa_decimais(item.c_e),
    };
}

export function formatar_numeros_tabela5(item: any) {
    return {
      ...item,
      t: formatarNumero_recebido_com_casa_decimais_aux(item.t, 5),
      m: formatarNumero_recebido_com_casa_decimais_aux(item.m, 5),
      k: formatarNumero_recebido_com_casa_decimais_aux(item.k, 5),
      l: formatarNumero_recebido_com_casa_decimais_aux(item.l, 5),
      n: formatarNumero_recebido_com_casa_decimais_aux(item.n, 5),
      po: formatarNumero_recebido_com_casa_decimais_aux(item.po, 5),
      k2o: formatarNumero_recebido_com_casa_decimais_aux(item.k2o, 5),
      mgo: formatarNumero_recebido_com_casa_decimais_aux(item.mgo, 5),
      cao: formatarNumero_recebido_com_casa_decimais_aux(item.cao, 5),
      so: formatarNumero_recebido_com_casa_decimais_aux(item.so, 5),
      // quantificacao: formatarNumero_recebido_com_casa_decimais_aux(item.quantificacao, 5)
    };
  }